import { render, staticRenderFns } from "./AdditionalCardNew.vue?vue&type=template&id=63b47cb9"
import script from "./AdditionalCardNew.vue?vue&type=script&lang=js"
export * from "./AdditionalCardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports